module.exports = __webpack_public_path__ + "static/scale-model-of-randyland-in-pittsburgh-pennsylvania-7982f376f9eb18a61842e5e046e03e90.png";